export default __webpack_public_path__ + "static/media/autosub.f92971a7.svg";